import React from "react";

function Erro() {
    return (
        <div className="container">
            <h1>Erro! Página não encontrada. :/</h1>
        </div>
    );
}

export default Erro;